import { render, staticRenderFns } from "./tgptDrawer.vue?vue&type=template&id=6b3b05cf&scoped=true"
import script from "./tgptDrawer.vue?vue&type=script&lang=js"
export * from "./tgptDrawer.vue?vue&type=script&lang=js"
import style0 from "./tgptDrawer.vue?vue&type=style&index=0&id=6b3b05cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b05cf",
  null
  
)

export default component.exports